<div class="modal active">
  <div class="modal__container modal__container--sm">
      <div class="fields">
          <h2 *ngIf="configurationController.terrainEditMode">Edit Terrain</h2>
          <h2 *ngIf="!configurationController.terrainEditMode">Add Terrain</h2>
          <div class="close" (click)="close()"><img src="/assets/img/close-white.svg" alt="" /></div>
          <div class="fields__container">
              <form autocomplete="off"  [formGroup]="configurationTerrainForm" class="active">
                  <div class="fields__block">
                      <div class="fields__block__section">
                          <div class="input-fields">
                              <div><label for="">Name</label><input name="name" type="text" formControlName="name" [(ngModel)]="terrain.name" maxlength="50"/></div>
                              <div>
                                <label for="">File</label>
                                <input type="file"
                                  id="zipFile"
                                  formControlName="zipFile"
                                  (change)="zipFilesUpload($event)"
                                  placeholder="Zip File"
                                  [accept]="importFormat.fileExtension">
                              </div>
                              <div><label for="">Type</label>
                                <select formControlName="terrainType" (change)="changeTerrainType()" [(ngModel)]="selectedType">
                                    <option *ngFor="let type of configurationController.terrainTypes" [ngValue]="type">{{type.type}}</option>
                                </select>
                              </div>
                              <div><label for="">Active</label>
                                <select formControlName="active" [(ngModel)]="terrain.active">
                                    <option [ngValue]="true">TRUE</option>
                                    <option [ngValue]="false">FALSE</option>
                                </select>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="fields__btn">
                    <button type="submit" [ngClass]="configurationTerrainForm.valid ? 'blue' : 'gray'" (click)="save();" [disabled]="!configurationTerrainForm.valid">Save</button>
                    <button type="button" class="gray" (click)="close()">Cancel</button>
                  </div>
              </form>
          </div>
      </div>
  </div>
</div>
